// extracted by mini-css-extract-plugin
export default {"profile":"history_entry_profile-module___profile___b7f7c67a","profileDetails":"history_entry_profile-module___profileDetails___e9d00f50"};